import React, { Fragment, useState, useEffect } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import { updateDb } from "../services/updateDb";
import { useAppContext } from "../AppContext";

import LoadPage from "../common/LoadPage";
import useAxiosFetch from "../common/useAxiosFetch";
import ConfirmationModal from "../common/ConfirmationModal";
import AlertMessage from "../common/AlertMessage";
import { useTranslation } from "react-i18next";

const RiskTemplatePage = () => {
  const { t } = useTranslation();
  const { alertMessage, showAlertMessage } = useAppContext();

  const navigate = useNavigate();
  const { data, loading, refetch } = useAxiosFetch("/api/risktemplates"); //forces a refresh when risk is updated/deleted

  let navigateEditRiskTemplate = (templateId) => {
    navigate(`/editrisktemplate?templateId=${templateId}`);
  };

  const [show, setShow] = useState(false);
  const [deleteRiskTemplate, setDeleteRiskTemplate] = useState();

  const handleClose = async (deleteRiskTemplate, templateId) => {
    setShow(false);

    if (deleteRiskTemplate && templateId) {
      const res = await updateDb("/api/risktemplates/" + templateId, {}, "delete");

      if (res.success) {
        refetch();
        showAlertMessage('error', t('risk_template') + " " + t('deleted'));
      }
      else {
        showAlertMessage('error', res.error ? res.error : 'Error deleting risk template.');
      }
    }
  };

  const handleShow = (templateId) => {
    setDeleteRiskTemplate(templateId);
    setShow(true);
  };

  if (loading)
    return <LoadPage />;

  return (
    <div id="content">

      <ConfirmationModal
        show={show}
        handleClose={handleClose}
        deleteId={deleteRiskTemplate}
      />

      <div className="content-header">
        <NavLink key="addRiskTemplate" to="/addrisktemplate">
          <div className="white-border-btn">+ {t('add_risk_template')}</div>
        </NavLink>
      </div>
      
      <AlertMessage type={alertMessage.type} message={alertMessage.content} />

      <div className="content-bubble content-bubble-table">

        <table className="overview-table">
          <thead>
            <tr>
              <td>{t('template')} {t('name').toLowerCase()}</td>
              <td>{t('risks_plural')}</td>
              <td>{t('security_standard')}</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <Fragment key={item["id"]}>
                  <tr>
                    <td>{item.name}</td>
                    <td>
                      {item.risks ? item.risks.length : 0}
                    </td>
                    <td>{item.securityStandard ? item.securityStandard : "ISO27001"}</td>
                    <td>
                      <i
                        onClick={() => navigateEditRiskTemplate(item["id"])}
                        className="icon-edit"
                      />
                      <i
                        onClick={() => handleShow(item["id"])}
                        className="icon-delete"
                      />
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RiskTemplatePage;
